module.exports = __webpack_public_path__ + "static/img/img-02.ee06f1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/slider/img-02.jpg
// module id = 79
// module chunks = 0